{
  "admin.loading": "Betöltés...",
  "admin.signedInAs": "Bejelentkezve mint",
  "admin.signOut": "Kijelentkezés",
  "admin.menu.profile": "Profil",
  "admin.menu.administration": "Adminisztráció",
  "admin.menu.preferences": "Beállítások",
  "admin.auth.subtitle": "Folytatáshoz jelentkezz be vagy hozz létre fiókot.",
  "admin.mode.signIn": "Bejelentkezés",
  "admin.mode.signUp": "Regisztráció",
  "admin.mode.forgotPassword": "Elfelejtett jelszó",
  "admin.mode.verifyEmail": "E-mail megerősítése",
  "admin.link.forgotPassword": "Elfelejtett jelszó?",
  "admin.link.backToSignIn": "Vissza a bejelentkezéshez",
  "admin.auth.switch.noAccount": "Nincs még fiókod?",
  "admin.auth.switch.haveAccount": "Már van fiókod?",
  "admin.field.email": "E-mail",
  "admin.field.password": "Jelszó",
  "admin.field.name": "Név",
  "admin.field.acceptTerms": "Elfogadom a felhasználási feltételeket",
  "admin.terms.prefix": "Elfogadom a",
  "admin.terms.linkLabel": "Felhasználási feltételeket",
  "admin.terms.modalTitle": "Felhasználási feltételek",
  "admin.terms.popupTitle": "Frissültek a felhasználási feltételek",
  "admin.terms.popupPrefix": "Frissítettük a",
  "admin.terms.popupSuffix": "A folytatáshoz nézd át és fogadd el a legfrissebb verziót.",
  "admin.terms.bannerMessage": "Frissülnek a felhasználási feltételeink, amelyek ekkortól lépnek hatályba: {effectiveDate}.",
  "admin.terms.bannerCta": "Kattints ide az áttekintéshez és elfogadáshoz.",
  "admin.field.receiveProductUpdates": "Szeretnék értesítéseket kapni a termék közelgő funkcióiról.",
  "admin.field.resetToken": "Visszaállító token (e-mailből)",
  "admin.field.newPassword": "Új jelszó",
  "admin.field.verificationToken": "Megerősítő token (e-mailből)",
  "admin.password.requirements": "Legalább 15 karakter, benne kisbetű, nagybetű, szám és speciális karakter.",
  "admin.password.rule.length": "Legalább 15 karakter",
  "admin.password.rule.uppercase": "Legalább 1 nagybetű (A-Z)",
  "admin.password.rule.lowercase": "Legalább 1 kisbetű (a-z)",
  "admin.password.rule.number": "Legalább 1 szám (0-9)",
  "admin.password.rule.special": "Legalább 1 speciális karakter",
  "admin.button.signingIn": "Bejelentkezés...",
  "admin.button.signIn": "Bejelentkezés",
  "admin.auth.button.creatingAccount": "Fiók létrehozása...",
  "admin.auth.button.createAccount": "Fiók létrehozása",
  "admin.button.acceptTerms": "Feltételek elfogadása",
  "admin.button.acceptingTerms": "Elfogadás...",
  "admin.button.close": "Bezárás",
  "admin.button.requesting": "Kérés küldése...",
  "admin.button.requestReset": "Visszaállítás kérése",
  "admin.button.updating": "Frissítés...",
  "admin.button.setNewPassword": "Új jelszó beállítása",
  "admin.button.verifying": "Ellenőrzés...",
  "admin.button.verifyEmail": "E-mail megerősítése",
  "admin.button.sending": "Küldés...",
  "admin.button.resendVerification": "Megerősítő e-mail újraküldése",
  "admin.auth.error.organizationDisabled": "Ez a szervezethez tartozó felhasználó le van tiltva.",
  "admin.auth.error.emailVerificationRequired": "Bejelentkezés előtt erősítsd meg az e-mail címed.",
  "admin.auth.error.forgotPasswordRequestFailed": "Sikertelen jelszó-visszaállítási kérelem.",
  "admin.auth.error.invalidCredentials": "Érvénytelen e-mail cím vagy jelszó.",
  "admin.auth.error.passwordResetInvalid": "Érvénytelen vagy lejárt token, vagy érvénytelen jelszó.",
  "admin.auth.error.robotDetectionFailed": "Az emberi ellenőrzés sikertelen volt. Próbáld újra.",
  "admin.auth.error.resendVerificationFailed": "Nem sikerült újraküldeni a megerősítő e-mailt.",
  "admin.auth.error.signUpFailed": "Sikertelen regisztráció.",
  "admin.auth.error.termsAcceptanceFailed": "Nem sikerült elfogadni a legfrissebb felhasználási feltételeket.",
  "admin.auth.error.twoFactorInvalid": "Érvénytelen vagy lejárt hitelesítési kód.",
  "admin.auth.error.userAlreadyExists": "Ez a felhasználó már létezik. Használd az elfelejtett jelszó funkciót.",
  "admin.auth.error.verifyEmailInvalid": "Érvénytelen vagy lejárt megerősítő token.",
  "admin.message.verifyBeforeSignIn": "Bejelentkezés előtt erősítsd meg az e-mail címed.",
  "admin.message.signInFailed": "Sikertelen bejelentkezés.",
  "admin.message.userExists": "Ez a felhasználó már létezik. Használd az elfelejtett jelszó funkciót.",
  "admin.auth.message.checkEmail": "Ellenőrizd az e-mailjeidet a fiókod megerősítéséhez.",
  "admin.message.signUpFailed": "Sikertelen regisztráció.",
  "admin.message.termsUnavailable": "A legfrissebb felhasználási feltételek jelenleg nem érhetőek el.",
  "admin.message.termsAcceptanceFailed": "Nem sikerült elfogadni a legfrissebb felhasználási feltételeket.",
  "admin.message.forgotPasswordRequested": "Ha létezik ilyen felhasználó, elküldtük a jelszó-visszaállító e-mailt.",
  "admin.message.forgotPasswordRequestFailed": "Sikertelen jelszó-visszaállítási kérelem.",
  "admin.message.passwordResetSuccess": "A jelszó frissítve lett.",
  "admin.message.passwordResetFailed": "Érvénytelen vagy lejárt token, vagy érvénytelen jelszó.",
  "admin.message.verifyEmailSuccess": "Az e-mail címet megerősítettük. Most már bejelentkezhetsz.",
  "admin.message.verifyEmailFailed": "Érvénytelen vagy lejárt megerősítő token.",
  "admin.auth.message.resendVerificationSuccess": "Ha a fiók még nincs megerősítve, új megerősítő e-mailt küldtünk.",
  "admin.message.resendVerificationFailed": "Nem sikerült újraküldeni a megerősítő e-mailt.",
  "admin.navlist.navigator": "Navigátor",
  "admin.navlist.title.organizations": "Szervezetek",
  "admin.navlist.title.sites": "Helyszínek",
  "admin.navlist.title.signs": "Táblák",
  "admin.navlist.title.translations": "Fordítások",
  "admin.navlist.parentFolderLabel": "..",
  "admin.navlist.parentFolder": "Szülőmappa",
  "admin.navlist.parentFolder.organizations": "Vissza a szervezetekhez",
  "admin.navlist.parentFolder.sites": "Vissza a helyszínekhez",
  "admin.navlist.parentFolder.signs": "Vissza a táblákhoz",
  "admin.navlist.loading": "Betöltés...",
  "admin.navlist.empty": "Nincsenek elemek.",
  "admin.navlist.scrollForMore": "Görgess a továbbiakért...",
  "admin.navlist.error.loadFailed": "Nem sikerült betölteni a listát.",
  "admin.navlist.error.selectOrganization": "Válassz szervezetet a helyszínek megtekintéséhez.",
  "admin.navlist.error.selectSite": "Válassz helyszínt a táblák megtekintéséhez.",
  "admin.navlist.error.selectSign": "Válassz táblát a fordítások megtekintéséhez.",
  "admin.navlist.openMobilePanel": "Navigáció megnyitása",
  "admin.navlist.closeMobilePanel": "Navigáció bezárása",
  "admin.navlist.openChildren": "Gyermekelemek megnyitása",
  "admin.navlist.includeArchived": "Archivált elemek mutatása",
  "admin.navlist.sort.label": "Rendezés",
  "admin.navlist.sort.createdAtAsc": "Létrehozás dátuma, régiek elöl",
  "admin.navlist.sort.createdAtDesc": "Létrehozás dátuma, újak elöl",
  "admin.navlist.sort.languageAsc": "Nyelvkód, A-Z",
  "admin.navlist.sort.languageDesc": "Nyelvkód, Z-A",
  "admin.navlist.sort.nameAsc": "Név, A-Z",
  "admin.navlist.sort.nameDesc": "Név, Z-A",
  "admin.navlist.searchPlaceholder": "Keresés névben és leírásban",
  "admin.navlist.searchLanguagesPlaceholder": "Nyelvek szűrése",
  "admin.navlist.searchAction": "Keresés",
  "admin.navlist.emptySearch": "Nincs találat.",
  "admin.navlist.expandPanel": "Panel kibontása",
  "admin.navlist.collapsePanel": "Panel összecsukása",
  "admin.navlist.resizePanel": "Bal oldali panel átméretezése",
  "admin.detail.eyebrow": "Részletek",
  "admin.detail.title.empty": "Részletek",
  "admin.detail.title.organization": "Szervezet",
  "admin.detail.title.site": "Helyszín",
  "admin.detail.title.sign": "Tábla",
  "admin.detail.title.translation": "Fordítás",
  "admin.detail.empty": "Válassz ki egy elemet a részletek megtekintéséhez.",
  "admin.detail.loading": "Részletek betöltése...",
  "admin.detail.error.loadFailed": "Nem sikerült betölteni a részleteket.",
  "admin.detail.error.saveFailed": "Nem sikerült menteni a módosításokat.",
  "admin.detail.error.archiveFailed": "Nem sikerült archiválni az elemet.",
  "admin.detail.error.unarchiveFailed": "Nem sikerült visszaállítani az elemet.",
  "admin.detail.helper": "Válassz egy elemet bal oldalt, vagy kattints a gombra egy új létrehozásához.",
  "admin.detail.confirm.discard": "Elveted a módosításokat?",
  "admin.detail.confirm.discardTitle": "Módosítások elvetése",
  "admin.detail.confirm.archive": "Archiválod ezt az elemet?",
  "admin.detail.confirm.archiveTitle": "Elem archiválása",
  "admin.detail.confirm.unarchive": "Visszaállítod ezt az elemet?",
  "admin.detail.confirm.unarchiveTitle": "Elem visszaállítása",
  "admin.popup.cancel": "Mégse",
  "admin.popup.close": "Bezárás",
  "admin.popup.confirm": "Megerősítés",
  "admin.organizationInvitation.accept": "Meghívó elfogadása",
  "admin.organizationInvitation.confirm.accept": "Elfogadod ezt a szervezeti meghívót?",
  "admin.organizationInvitation.confirm.decline": "Elutasítod ezt a szervezeti meghívót?",
  "admin.organizationInvitation.decline": "Meghívó elutasítása",
  "admin.organizationInvitation.result.accepted": "A meghívót elfogadtad.",
  "admin.organizationInvitation.result.alreadyAccepted": "Ezt a meghívót már elfogadták.",
  "admin.organizationInvitation.result.alreadyDeclined": "Ezt a meghívót már elutasították.",
  "admin.organizationInvitation.result.belongsToAnotherUser": "Ez a meghívó másik felhasználóhoz tartozik. Jelentkezz be a meghívott felhasználóval a válaszadáshoz.",
  "admin.organizationInvitation.result.cancelled": "Ezt a meghívót visszavonták.",
  "admin.organizationInvitation.result.declined": "A meghívót elutasítottad.",
  "admin.organizationInvitation.result.expired": "Ez a meghívó lejárt.",
  "admin.organizationInvitation.result.expiredOrResolved": "Ez a meghívó lejárt, vagy már elfogadták, illetve elutasították.",
  "admin.organizationInvitation.result.invalid": "Ez a meghívó érvénytelen.",
  "admin.organizationInvitation.title": "Szervezeti meghívó",
  "admin.organizationInvitation.title.accept": "Meghívó elfogadása",
  "admin.organizationInvitation.title.decline": "Meghívó elutasítása",
  "admin.detail.action.create": "Létrehozás",
  "admin.detail.action.edit": "Szerkesztés",
  "admin.detail.action.save": "Mentés",
  "admin.detail.action.discard": "Elvetés",
  "admin.detail.action.archive": "Archiválás",
  "admin.detail.action.unarchive": "Visszaállítás",
  "admin.detail.action.delete": "Törlés",
  "admin.detail.action.hideNavigator": "Navigátor elrejtése",
  "admin.detail.action.showNavigator": "Navigátor megjelenítése",
  "admin.detail.action.createOrganization": "Szervezet létrehozása",
  "admin.detail.action.createSite": "Helyszín létrehozása",
  "admin.detail.action.createSign": "Tábla létrehozása",
  "admin.detail.action.createTranslation": "Fordítás létrehozása",
  "admin.permission.disabledTooltipSuffix": "(nem engedélyezett)",
  "admin.dataProblem.disabledTooltipSuffix": "(adatprobléma)",
  "admin.subscription.limitReachedTooltipSuffix": "(előfizetési limit elérve)",
  "admin.subscription.currentAmount": "jelenlegi",
  "admin.subscription.limitAmount": "limit",
  "admin.subscription.expiredBanner": "A jogosultságok az előfizetés lejárata miatt vissza lettek vonva, és minden adat most már csak olvasható.",
  "admin.detail.field.id": "Azonosító",
  "admin.detail.field.organizationId": "Szervezet azonosító",
  "admin.detail.field.siteId": "Helyszín azonosító",
  "admin.detail.field.signId": "Tábla azonosító",
  "admin.detail.field.uuid": "UUID",
  "admin.detail.field.name": "Név",
  "admin.detail.field.email": "E-mail",
  "admin.detail.field.emailLanguage": "Levelezési nyelv",
  "admin.detail.field.role": "Szerepkör",
  "admin.detail.field.description": "Leírás",
  "admin.detail.field.language": "Nyelv",
  "admin.detail.field.content": "Tartalom",
  "admin.detail.field.viewUrl": "Megtekintési URL",
  "admin.detail.field.qrCode": "QR-kód",
  "admin.detail.field.archivedAt": "Archiválva",
  "admin.detail.field.expiresAt": "Lejárat",
  "admin.detail.field.maxActiveSites": "Max aktív helyszín",
  "admin.detail.field.maxActiveSigns": "Max aktív tábla",
  "admin.detail.field.maxActiveTranslations": "Max aktív fordítás",
  "admin.detail.field.maxTranslationLength": "Max fordításhossz",
  "admin.detail.field.maxActiveUsers": "Max aktív felhasználó",
  "admin.copy.copy": "Másolás",
  "admin.copy.copied": "Kimásolva",
  "admin.export.svg": "SVG export",
  "admin.export.saved": "Mentve",
  "admin.detail.visibility.public": "Ez az információ nyilvános felhasználók számára is megjelenik, amikor a táblákat megtekintik.",
  "admin.detail.visibility.internal": "Ez belső technikai információ csak neked, a nyilvánosság számára nem látható.",
  "admin.detail.language.DE": "Német",
  "admin.detail.language.EN": "Angol",
  "admin.detail.language.ES": "Spanyol",
  "admin.detail.language.FR": "Francia",
  "admin.detail.language.HU": "Magyar",
  "admin.markdownEditor.sourceLabel": "Markdown forras",
  "admin.route.placeholder.eyebrow": "Nincs implementálva",
  "admin.route.profile.title": "Profil",
  "admin.route.profile.description": "A profilbeállítások még nem elérhetők.",
  "admin.route.administration.title": "Adminisztráció",
  "admin.route.administration.description": "Az adminisztrációs eszközök nem érhetők el.",
  "admin.administration.title": "Adminisztráció",
  "admin.administration.tabs.title": "Adminisztrációs szekciók",
  "admin.administration.tab.disableUser": "Felhasználó letiltása",
  "admin.administration.tab.systemInformation": "Rendszerinformáció",
  "admin.administration.disableUser.submit": "Felhasználó letiltása",
  "admin.administration.disableUser.submitting": "Letiltás...",
  "admin.administration.disableUser.success": "A felhasználót letiltottuk.",
  "admin.administration.disableUser.error": "Nem sikerült letiltani a felhasználót.",
  "admin.administration.systemInformation.applicationVersion": "Alkalmazásverzió",
  "admin.administration.systemInformation.environment": "Környezet",
  "admin.administration.systemInformation.gitBranch": "Git ág",
  "admin.administration.systemInformation.gitCommitId": "Git commit",
  "admin.administration.systemInformation.error": "Nem sikerült betölteni a rendszerinformációkat.",
  "admin.profile.title": "A profilod",
  "admin.profile.tabs.title": "Profil szekciók",
  "admin.profile.tab.basic": "Alapadatok",
  "admin.profile.tab.security": "Biztonság",
  "admin.profile.tab.terms": "Elfogadott feltételek",
  "admin.profile.role.superAdmin": "Szuperadmin",
  "admin.profile.role.user": "Felhasználó",
  "admin.profile.terms.empty": "Még nincs elfogadott felhasználási feltétel.",
  "admin.profile.terms.acceptedAt": "Elfogadva",
  "admin.profile.terms.effectiveFrom": "Hatályos ettől",
  "admin.profile.terms.actions": "Műveletek",
  "admin.profile.terms.open": "Feltételek megnyitása",
  "admin.organization.tabs.title": "Szervezet szekciók",
  "admin.organization.tab.details": "Részletek",
  "admin.organization.tab.domains": "Domainek",
  "admin.organization.tab.internals": "Belső adatok",
  "admin.organization.tab.users": "Felhasználók",
  "admin.organization.tab.subscription": "Előfizetés",
  "admin.organization.internals.crmId": "CRM ID",
  "admin.organization.domains.empty": "A domain beállítások nem érhetők el.",
  "admin.organization.domains.enable": "Engedélyezés",
  "admin.organization.domains.disable": "Tiltás",
  "admin.organization.domains.enabled": "Engedélyezve",
  "admin.organization.domains.disabled": "Tiltva",
  "admin.organization.domains.status": "Állapot",
  "admin.organization.domains.status.active": "Aktív",
  "admin.organization.domains.status.archived": "Archivált",
  "admin.organization.domains.createdAt": "Létrehozva",
  "admin.organization.domains.section.trial": "Próba domain",
  "admin.organization.domains.section.managed": "Kezelt domainek",
  "admin.organization.domains.section.connected": "Kapcsolt domainek",
  "admin.organization.domains.type.CONNECTED": "Kapcsolt",
  "admin.organization.domains.type.EDGE": "Edge",
  "admin.organization.domains.type.MANAGED": "Kezelt",
  "admin.organization.domains.type.TRIAL": "Próba",
  "admin.organization.domains.trial.enabled": "Elérés engedélyezése a megosztott próba hosztnéven",
  "admin.organization.domains.trial.hostname": "Próba hosztnév",
  "admin.organization.domains.trial.enableTitle": "Próba domain engedélyezése",
  "admin.organization.domains.trial.enableConfirm": "Engedélyezed az elérést a megosztott próba hosztnéven?",
  "admin.organization.domains.trial.disableTitle": "Próba domain tiltása",
  "admin.organization.domains.trial.disableConfirm": "Tiltod az elérést a megosztott próba hosztnéven?",
  "admin.organization.domains.managed.add": "Kezelt domain hozzáadása",
  "admin.organization.domains.managed.empty": "Nincsenek kezelt domainek.",
  "admin.organization.domains.managed.hostname": "Hosztnév",
  "admin.organization.domains.managed.label": "Címke",
  "admin.organization.domains.managed.archiveTitle": "Kezelt domain archiválása",
  "admin.organization.domains.managed.archiveConfirm": "Archiválod ezt a kezelt domaint?",
  "admin.organization.domains.managed.unarchiveTitle": "Kezelt domain visszaállítása",
  "admin.organization.domains.managed.unarchiveConfirm": "Visszaállítod ezt a kezelt domaint?",
  "admin.organization.domains.managed.deleteTitle": "Kezelt domain törlése",
  "admin.organization.domains.managed.deleteConfirm": "Törlöd ezt az archivált kezelt domaint?",
  "admin.organization.domains.managed.availability.checking": "Elérhetőség ellenőrzése...",
  "admin.organization.domains.managed.availability.available": "Ez a kezelt domain elérhető.",
  "admin.organization.domains.managed.availability.unavailable": "Ez a kezelt domain nem érhető el.",
  "admin.organization.domains.connected.add": "Kapcsolt domain hozzáadása",
  "admin.organization.domains.connected.empty": "Nincsenek kapcsolt domainek.",
  "admin.organization.domains.connected.hostname": "Hosztnév",
  "admin.organization.domains.connected.target": "Kezelt cél domain",
  "admin.organization.domains.connected.targetMissing": "A kezelt domain hiányzik",
  "admin.organization.domains.connected.verified": "Ellenőrizve",
  "admin.organization.domains.connected.notVerified": "Nincs ellenőrizve",
  "admin.organization.domains.connected.notVerifiedYet": "Még nincs ellenőrizve",
  "admin.organization.domains.connected.verify": "Ellenőrzés",
  "admin.organization.domains.connected.archiveTitle": "Kapcsolt domain archiválása",
  "admin.organization.domains.connected.archiveConfirm": "Archiválod ezt a kapcsolt domaint?",
  "admin.organization.domains.connected.unarchiveTitle": "Kapcsolt domain visszaállítása",
  "admin.organization.domains.connected.unarchiveConfirm": "Visszaállítod ezt a kapcsolt domaint? Ezután újra nem ellenőrzött lesz.",
  "admin.organization.domains.connected.deleteTitle": "Kapcsolt domain törlése",
  "admin.organization.domains.connected.deleteConfirm": "Törlöd ezt az archivált kapcsolt domaint?",
  "admin.organization.domains.connected.verifyTitle": "Kapcsolt domain ellenőrzése",
  "admin.organization.domains.connected.verifySucceeded": "Az ellenőrzés sikeres volt.",
  "admin.organization.domains.connected.actualTarget": "Észlelt cél",
  "admin.organization.domains.connected.overrideLabel": "Ellenőrzés felülbírálása",
  "admin.organization.domains.connected.overrideVerified": "Jelöld ezt a kapcsolt domaint ellenőrzöttnek akkor is, ha a DNS ellenőrzés sikertelen.",
  "admin.organization.domains.connected.saveVerified": "Mentés ellenőrzöttként",
  "admin.organization.domains.connected.recordType": "Rekord típus",
  "admin.organization.domains.connected.recordTarget": "Rekord cél",
  "admin.organization.domains.connected.setupHint": "Az ellenőrzés előtt hozd létre ezt a CNAME rekordot az ügyfél DNS-ében.",
  "admin.organization.domains.error.organizationNotFound": "A szervezet nem található.",
  "admin.organization.domains.error.settingsNotFound": "A domain beállítások nem találhatók.",
  "admin.organization.domains.error.managedLabelInvalid": "A kezelt domain címkéje érvénytelen.",
  "admin.organization.domains.error.managedLabelReserved": "Ez a kezelt domain címke fenntartott.",
  "admin.organization.domains.error.managedLabelUnavailable": "Ez a kezelt domain címke nem érhető el.",
  "admin.organization.domains.error.managedHostnameUnavailable": "Ez a kezelt domain hosztnév már létezik a DNS-ben.",
  "admin.organization.domains.error.managedDomainNotFound": "A kezelt domain nem található.",
  "admin.organization.domains.error.managedDomainArchived": "A kezelt domain archiválva van.",
  "admin.organization.domains.error.managedDomainInUse": "A kezelt domaint még használja kapcsolt domain.",
  "admin.organization.domains.error.dnsConfigurationInvalid": "A DNS konfiguráció hiányos.",
  "admin.organization.domains.error.dnsOperationFailed": "A DNS művelet meghiúsult.",
  "admin.organization.domains.error.connectedHostnameInvalid": "A kapcsolt domain hosztneve érvénytelen.",
  "admin.organization.domains.error.connectedHostnameUnavailable": "Ez a kapcsolt domain hosztnév már használatban van ennél a szervezetnél.",
  "admin.organization.domains.error.connectedApexNotAllowed": "Apex domainek itt nem engedélyezettek.",
  "admin.organization.domains.error.connectedDomainNotFound": "A kapcsolt domain nem található.",
  "admin.organization.domains.error.connectedDomainArchived": "A kapcsolt domain archiválva van.",
  "admin.organization.domains.error.connectedCnameNotFound": "Nem található CNAME rekord a kapcsolt domainhez.",
  "admin.organization.domains.error.connectedTargetMismatch": "A kapcsolt domain rossz kezelt célra mutat.",
  "admin.sign.viewDomain.selected": "QR domain",
  "admin.sign.viewDomain.warning.managed": "Kapcsolt domain is elérhető. A QR-kódot inkább kapcsolt domainnel generáld, ne kezelt domainnel.",
  "admin.sign.viewDomain.warning.trial": "Magasabb prioritású domain is elérhető. A QR-kódot inkább kapcsolt vagy kezelt domainnel generáld, ne próba domainnel.",
  "admin.organization.subscription.empty": "Az előfizetés részletei nem érhetők el.",
  "admin.organization.subscription.group.organization": "Szervezet",
  "admin.organization.subscription.group.sites": "Helyszínek",
  "admin.organization.subscription.group.signs": "Táblák",
  "admin.organization.subscription.group.translations": "Fordítások",
  "admin.organization.subscription.preset.twoWeeks": "Most + 2 hét",
  "admin.organization.subscription.preset.oneMonth": "Most + 1 hónap",
  "admin.organization.subscription.preset.oneYear": "Most + 1 év",
  "admin.site.tabs.title": "Helyszín szakaszai",
  "admin.site.tab.details": "Részletek",
  "admin.sign.tabs.title": "Tábla szakaszai",
  "admin.sign.tab.details": "Részletek",
  "admin.sign.tab.urls": "URL-ek",
  "admin.sign.urls.empty": "Ehhez a táblához még nem érhető el URL.",
  "admin.translation.tabs.title": "Fordítás szakaszai",
  "admin.translation.tab.details": "Részletek",
  "admin.organizationUsers.add": "Felhasználó hozzáadása",
  "admin.organizationUsers.cancelInvitation": "Meghívó visszavonása",
  "admin.organizationUsers.cancelInvitationConfirm": "Visszavonod a meghívót ennél a felhasználónál:",
  "admin.organizationUsers.changeRole": "Szerepkör módosítása",
  "admin.organizationUsers.currentUser": "Jelenlegi felhasználó",
  "admin.translation.lengthExceededBanner": "Elérted a szervezet előfizetése által engedélyezett maximális fordításhosszt.",
  "admin.organizationUsers.empty": "Nincs felhasználó vagy függő meghívó.",
  "admin.organizationUsers.emptyName": "Nincs név",
  "admin.organizationUsers.error.cancelInvitationFailed": "Nem sikerült visszavonni a meghívót.",
  "admin.organizationUsers.error.inviteFailed": "Nem sikerült meghívni a felhasználót.",
  "admin.organizationUsers.error.loadFailed": "Nem sikerült betölteni a szervezet felhasználóit.",
  "admin.organizationUsers.error.removeFailed": "Nem sikerült eltávolítani a felhasználót.",
  "admin.organizationUsers.error.resendInvitationFailed": "Nem sikerült újraküldeni a meghívót.",
  "admin.organizationUsers.error.roleFailed": "Nem sikerült módosítani a szerepkört.",
  "admin.organizationUsers.invite": "Meghívás",
  "admin.organizationUsers.invitedUntil": "Meghívó lejárata",
  "admin.organizationUsers.notApplicable": "N/A",
  "admin.organizationUsers.remove": "Felhasználó eltávolítása",
  "admin.organizationUsers.removeConfirm": "Eltávolítod ezt a felhasználót a szervezetből:",
  "admin.organizationUsers.resendInvitation": "Meghívó e-mail újraküldése",
  "admin.organizationUsers.resendInvitationConfirm": "Újraküldöd a meghívó e-mailt? A korábbi meghívólink érvényét veszti ennél a felhasználónál:",
  "admin.organizationUsers.role.ADMINISTRATOR": "Adminisztrátor",
  "admin.organizationUsers.role.EDITOR": "Szerkesztő",
  "admin.organizationUsers.role.OWNER": "Tulajdonos",
  "admin.organizationUsers.role.VIEWER": "Megtekintő",
  "admin.organizationUsers.status": "Állapot",
  "admin.organizationUsers.status.active": "Aktív",
  "admin.organizationUsers.status.invited": "Meghívva",
  "admin.twoFactor.account": "Fiók",
  "admin.twoFactor.authenticatorPrompt": "Add meg a hitelesítő alkalmazásban látható kódot.",
  "admin.twoFactor.code": "Hitelesítési kód",
  "admin.twoFactor.codeName": "Kód neve",
  "admin.twoFactor.confirmAuthenticator": "Hitelesítő megerősítése",
  "admin.twoFactor.confirmCode": "Kód a hitelesítőből",
  "admin.twoFactor.disableConfirmBody.account": "Kikapcsolod a kétfaktoros hitelesítést a fiókodhoz?",
  "admin.twoFactor.disableConfirmTitle": "Kétfaktoros hitelesítés kikapcsolása",
  "admin.twoFactor.digits": "Számjegyek",
  "admin.twoFactor.disable": "2FA kikapcsolása",
  "admin.twoFactor.emailPrompt": "Elküldtük a bejelentkezési kódot az e-mail címedre.",
  "admin.twoFactor.enableEmail": "E-mail kódok használata",
  "admin.twoFactor.error.disableFailed": "Nem sikerült kikapcsolni a kétfaktoros hitelesítést.",
  "admin.twoFactor.error.enableFailed": "Nem sikerült bekapcsolni a kétfaktoros hitelesítést.",
  "admin.twoFactor.error.invalidCode": "A hitelesítő kód érvénytelen.",
  "admin.twoFactor.error.setupFailed": "Nem sikerült elindítani a hitelesítő beállítását.",
  "admin.twoFactor.issuer": "Kibocsátó",
  "admin.twoFactor.period": "Időszak másodpercben",
  "admin.twoFactor.recommendationBody.account": "Védd a fiókodat hitelesítő alkalmazással vagy e-mailes bejelentkezési kóddal. Ezt most beállíthatod a profil biztonsági beállításai között.",
  "admin.twoFactor.recommendationCta": "Biztonsági beállítások megnyitása",
  "admin.twoFactor.recommendationTitle": "Kétfaktoros hitelesítés hozzáadása",
  "admin.twoFactor.secret": "Titok",
  "admin.twoFactor.sectionTitle": "Kétfaktoros hitelesítés",
  "admin.twoFactor.setupAuthenticator": "Hitelesítő alkalmazás beállítása",
  "admin.twoFactor.setupInstructions": "Tölts le egy TOTP hitelesítő alkalmazást, például Google Authenticatort, Microsoft Authenticatort vagy hasonlót, majd olvasd be ezt a QR-kódot vagy add meg kézzel az alábbi adatokat.",
  "admin.twoFactor.status.disabled": "A kétfaktoros hitelesítés nincs bekapcsolva.",
  "admin.twoFactor.status.email": "A kétfaktoros hitelesítés e-mail kódokkal van bekapcsolva.",
  "admin.twoFactor.status.totp": "A kétfaktoros hitelesítés hitelesítő alkalmazással van bekapcsolva.",
  "admin.twoFactor.switchToEmailConfirmBody": "Átváltod a kétfaktoros hitelesítést hitelesítő alkalmazásról e-mail kódokra?",
  "admin.twoFactor.switchToEmailConfirmTitle": "Váltás e-mail kódokra",
  "admin.twoFactor.timeBased": "Időalapú",
  "admin.twoFactor.type": "Típus",
  "admin.twoFactor.verify": "Kód ellenőrzése",
  "admin.twoFactor.yourKey": "Kulcsod",
  "admin.sessions.description": "Aktív munkamenetek érvénytelenítése más böngészőkben és eszközökön. A jelenlegi munkamenet aktív marad.",
  "admin.sessions.current": "Jelenlegi munkamenet",
  "admin.sessions.empty": "Nincs aktív munkamenet.",
  "admin.sessions.expiresAt": "Lejárat",
  "admin.sessions.invalidateFailed": "Nem sikerült érvényteleníteni a többi munkamenetet.",
  "admin.sessions.invalidate": "Érvénytelenítés",
  "admin.sessions.invalidateOthers": "Többi munkamenet érvénytelenítése",
  "admin.sessions.invalidateSuccess": "A többi munkamenetet érvénytelenítettük.",
  "admin.sessions.ipAddress": "IP-cím",
  "admin.sessions.lastAccessedAt": "Utolsó aktivitás",
  "admin.sessions.loginAt": "Bejelentkezés ideje",
  "admin.sessions.sectionTitle": "Aktív munkamenetek",
  "admin.sessions.userAgent": "Eszköz / user agent",
  "admin.route.preferences.title": "Preferenciák",
  "admin.route.preferences.description": "A preferenciák a személyre szabás bevezetése után lesznek elérhetők.",
  "admin.route.notFound.title": "Nem található",
  "admin.route.notFound.description": "A kért nézet nem érhető el az admin felületen.",
  "view.defaultTitle": "Renderelt Markdown",
  "view.selectLanguage": "Nyelv kiválasztása",
  "view.speech.play": "Hang lejátszása",
  "view.speech.pause": "Hang szüneteltetése",
  "view.speech.resetHint": "Tartsd nyomva 2 másodpercig az elejére állításhoz.",
  "view.loading": "Betöltés...",
  "view.loadFailed": "Nem sikerült betölteni a fordítást.",
  "view.unavailable": "A kért oldal nem érhető el.",
  "view.termsOfUseLoadFailed": "Nem sikerült betölteni a felhasználási feltételeket.",
  "view.noContent": "Nincs megjeleníthető tartalom.",
  "view.termsOfUse.notLatest": "Ez nem a legfrissebb felhasználási feltételek verziója.",
  "view.termsOfUse.openLatest": "Legfrissebb verzió megnyitása",
  "view.chooseLanguage": "Nyelv kiválasztása",
  "view.closeLanguageSelector": "Nyelvválasztó bezárása",
  "view.closeReportAbuseDialog": "Visszaélés jelentése ablak bezárása",
  "view.filterLanguagesPlaceholder": "Nyelvek szűrése...",
  "view.filterLanguagesAria": "Nyelvek szűrése angol vagy anyanyelvi név alapján",
  "view.reportAbuse.thankYou": "Köszönjük, hogy jelzed a nem megfelelő használatot vagy viselkedést.",
  "view.reportAbuse.instructions": "Kérünk, adj meg minél több részletet, beleértve a fordítás linkjét is.",
  "view.reportAbuse.opensEmailClient": "Az alábbi gomb megnyitja az e-mail kliensedet. Előfordulhat, hogy előre kitölti a levél tárgyát és a törzs egy részét. Kérünk, ezeket hagyd meg, és a visszajelzésedet ezek után írd be.",
  "request.error.accessDenied": "Nincs jogosultságod a művelet végrehajtásához.",
  "request.error.activeSubscriptionNotFound": "Az aktív előfizetés nem található.",
  "request.error.authenticationRequired": "A folytatáshoz jelentkezz be.",
  "request.error.connectedDomainApexNotAllowed": "Az apex domainek itt nem engedélyezettek.",
  "request.error.connectedDomainArchived": "A csatlakoztatott domain archiválva van.",
  "request.error.connectedDomainCnameNotFound": "A csatlakoztatott domain CNAME rekordja nem található.",
  "request.error.connectedDomainHostnameInvalid": "A csatlakoztatott domain hosztneve érvénytelen.",
  "request.error.connectedDomainHostnameUnavailable": "A csatlakoztatott domain hosztneve nem érhető el.",
  "request.error.connectedDomainNotFound": "A csatlakoztatott domain nem található.",
  "request.error.connectedDomainTargetMismatch": "A csatlakoztatott domain nem a várt célra mutat.",
  "request.error.correlationId": "Korrelációs azonosító",
  "request.error.dnsConfigurationInvalid": "A DNS konfiguráció érvénytelen.",
  "request.error.dnsOperationFailed": "A DNS művelet nem sikerült.",
  "request.error.emailVerificationRequired": "Az e-mail-cím megerősítése szükséges.",
  "request.error.generic": "Valami hiba történt. Próbáld újra.",
  "request.error.invalidCredentials": "A hitelesítési adatok érvénytelenek.",
  "request.error.invitationInvalid": "A meghívó érvénytelen.",
  "request.error.invitationNotFound": "A meghívó nem található.",
  "request.error.managedDomainArchived": "A kezelt domain archiválva van.",
  "request.error.managedDomainHostnameUnavailable": "A kezelt domain hosztnév már létezik a DNS-ben.",
  "request.error.managedDomainInUse": "A kezelt domain használatban van.",
  "request.error.managedDomainLabelInvalid": "A kezelt domain címkéje érvénytelen.",
  "request.error.managedDomainLabelReserved": "A kezelt domain címkéje foglalt.",
  "request.error.managedDomainLabelUnavailable": "A kezelt domain címkéje nem érhető el.",
  "request.error.managedDomainNotFound": "A kezelt domain nem található.",
  "request.error.notFound": "A kért elem nem található.",
  "request.error.organizationDisabled": "A szervezet le van tiltva.",
  "request.error.organizationDomainSettingsNotFound": "A szervezet domain beállításai nem találhatók.",
  "request.error.organizationNotFound": "A szervezet nem található.",
  "request.error.organizationUserMembershipNotFound": "A szervezeti tagság nem található.",
  "request.error.passwordResetInvalid": "A jelszó-visszaállítási kérés érvénytelen.",
  "request.error.profileNotFound": "A profil nem található.",
  "request.error.sessionNotFound": "A munkamenet nem található.",
  "request.error.signNotFound": "A tábla nem található.",
  "request.error.siteNotFound": "A helyszín nem található.",
  "request.error.termsOfUseNotFound": "A felhasználási feltételek nem találhatók.",
  "request.error.totpCodeInvalid": "A hitelesítő alkalmazás kódja érvénytelen.",
  "request.error.totpSetupRequired": "Előbb el kell indítani a hitelesítő beállítását.",
  "request.error.translationMaxLengthExceeded": "A fordítás meghaladja a megengedett maximális hosszúságot.",
  "request.error.translationNotFound": "A fordítás nem található.",
  "request.error.unexpected": "Váratlan hiba történt.",
  "request.error.userAlreadyExists": "A felhasználó már létezik.",
  "request.error.userNotFound": "A felhasználó nem található.",
  "request.error.validation": "A kérés nem dolgozható fel.",
  "request.error.verifyEmailInvalid": "Az e-mail megerősítési kérés érvénytelen.",
  "footer.about": "Rólunk",
  "footer.terms": "Használati feltételek",
  "footer.cookies": "Cookie beállítások",
  "footer.reportAbuse": "Visszaélés jelentése",
  "theme.label.system": "Téma: rendszer",
  "theme.label.light": "Téma: világos",
  "theme.label.dark": "Téma: sötét",
  "uiLanguage.switcherAria": "Felület nyelvének váltása",
  "toolbar.toggleGroup": "kapcsolócsoport",
  "toolbar.richText": "Vizuális szerkesztő",
  "toolbar.source": "Forrás mód",
  "toolbar.blockTypes.paragraph": "Bekezdés",
  "toolbar.blockTypes.quote": "Idézet",
  "toolbar.blockTypes.heading": "{{level}}. szintű címsor",
  "toolbar.blockTypeSelect.selectBlockTypeTooltip": "Blokk típus kiválasztása",
  "toolbar.blockTypeSelect.placeholder": "Blokk típus",
  "toolbar.bold": "Félkövér",
  "toolbar.removeBold": "Félkövér eltávolítása",
  "toolbar.italic": "Dőlt",
  "toolbar.removeItalic": "Dőlt eltávolítása",
  "toolbar.underline": "Aláhúzott",
  "toolbar.removeUnderline": "Aláhúzás eltávolítása",
  "toolbar.bulletedList": "Felsorolás",
  "toolbar.numberedList": "Számozott lista",
  "toolbar.checkList": "Jelölőlista",
  "toolbar.link": "Hivatkozás létrehozása",
  "toolbar.codeBlock": "Kódblokk beszúrása",
  "toolbar.undo": "Visszavonás {{shortcut}}",
  "toolbar.redo": "Újra {{shortcut}}"
}
